import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_APP102_Request,
  IAPI_APP102_Response,
  IAPI_APP104_Request,
  IAPI_APP104_Response,
} from "../../../type/apiType";

/**
 * メール内容登録・更新表示API
 * @returns httpAPI_APP102
 */
const httpAPI_APP102 = async (
  param: IAPI_APP102_Request
): Promise<IAPI_APP102_Response> => {
  const res = await http.post(ApiUrl.API_APP102, {
    ...param,
  });

  return res.data;
};

/**
 * メール内容情報更新API
 * @returns httpAPI_APP104
 */
const httpAPI_APP104 = async (
  param: IAPI_APP104_Request
): Promise<IAPI_APP104_Response> => {
  const res = await http.post(ApiUrl.API_APP104, {
    ...param,
  });

  return res.data;
};

export { httpAPI_APP102, httpAPI_APP104 };
